var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTgChannel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "-0.75 -0.2 13.5 13.5"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 1.26c0-.567-.67-.946-1.234-.665-.758.378-3.002 1.478-4.345 1.963-1.564.563-2.91.775-4.452.84C.9 3.443 0 4.227 0 5.238v2.42c0 1.012.9 1.795 1.969 1.84q.273.012.54.03l-.496 2.248a.56.56 0 0 0 .099.454c.098.134.25.227.424.258a.72.72 0 0 0 .5-.09.6.6 0 0 0 .285-.385l.515-2.34c.842.13 1.677.338 2.585.666 1.343.484 3.586 1.585 4.345 1.962.564.282 1.234-.097 1.234-.664zM4 8.47c.945.143 1.889.375 2.913.744 1.102.397 2.724 1.162 3.754 1.662V2.02c-1.03.5-2.652 1.265-3.754 1.662-1.024.37-1.968.602-2.913.744zM2.667 4.573q-.315.021-.636.035c-.402.017-.698.305-.698.63V7.66c0 .325.296.613.698.63q.321.014.636.036z",
  clipRule: "evenodd"
})));
export default SvgTgChannel;